import { composeFetch } from '@library/http'
import {
  composeRequest,
  addPath,
  setServiceUrl,
  setMethod,
  setQueryParams,
  goustoHeaders,
} from '@library/http/requests'
import { MenuRecipe } from './types'
import { getAuthUserId } from '@library/auth'
import { SUPPORTED_OPTION_TYPES_INGREDIENTS } from '../../internal/types'

export type MenuRecipeParams = {
  menuId: string
  recipeId: string
  numPortions: number
  deliveryDate: string
  collectionId?: string
}

const menuApiMenuRecipeParse = async (response: Response): Promise<MenuRecipe> => {
  const body = await response.text()
  const parsedBody = JSON.parse(body)

  if (!response.ok) {
    throw new Error(parsedBody.message)
  }

  return parsedBody as MenuRecipe
}

const menuApiMenuRecipeRequest = composeRequest(
  setServiceUrl('menu', 3),
  addPath(({ menuId, recipeId }: MenuRecipeParams) => `menus/${menuId}/recipes/${recipeId}`),
  goustoHeaders,
  setQueryParams(({ numPortions, deliveryDate, collectionId }: MenuRecipeParams) => {
    const userId = getAuthUserId()
    return {
      num_portions: numPortions.toString(),
      delivery_date: deliveryDate,
      option_types: [...SUPPORTED_OPTION_TYPES_INGREDIENTS],
      ...(userId && { user_id: userId }),
      ...(collectionId && { collection_id: collectionId }),
    }
  }),
  setMethod('GET'),
)

export const menuRecipeFetcher = composeFetch(menuApiMenuRecipeRequest, menuApiMenuRecipeParse)
